import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const IntroducingSayman = () => {
    return (
        <div className="introducing-sayman-wrapper">
            <div className="container introducing-container">
                <h2 className="introducing-title text-center">معرفی سایمان دیجیتال</h2>
                <div className="text-movie-box position-relative text-center">
                    <div className="float-color--1 float-color"></div>
                    <div className="float-color--2 float-color"></div>
                    <div className="movie-box movie-screen-box">
                        <video poster="./assets/sample-image/photo_2021-10-31_15-50-42.png" className="screen-video">
                            <source src="./assets/video/video1.mp4" type="video/mp4"/>
                        </video>
                        <IconName name="play" className="icon play-icon video-play-button"/>
                    </div>
                    <div className="text-box">
                        <p className="text">
                            ما یک قصّه‌ی بلند و جذّاب داریم. قصّه‌ی آدم‌هایی که هر روزشان با روز قبل فرق دارد. دیجی‌کالا
                            یک خانواده است و هرکدام از اعضای این خانواده رویاها، غم‌ها و شادی‌های خودشان را دارند. امّا
                            چیزی که این قصه را جلو می‌برد، این است که: «ما همیشه با همیم!» قصه‌ی ما را در صفحه‌ی
                            اینستاگرام «دیجی‌کالا لایف» دنبال کنید. شاید به شما کمک کند تا قصه‌ی خودتان را بسازید یا
                            شاید با ما هم‌داستان شوید!
                        </p>
                    </div>
                    <div className="float-color--3 float-color"></div>
                    <div className="float-color--4 float-color"></div>
                    <div className="float-color--5 float-color"></div>
                </div>
            </div>
        </div>
    );
};

export default IntroducingSayman;
